import {
  HASH_LOADING,
  HASH_SUCCESS,
  HASH_ERROR,
  HASH_LOGOUT,
} from "../../ActionTypes";
import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";

/* export const wsPostHash = (dtoHash, next) => (dispatch) => {
  axiosInstance().then((respuesta) => {
    respuesta
      .post(`auth/hash`, dtoHash)
      .then((resp) => {
        dispatch({ type: HASH_SUCCESS, payload: resp.data });
        next(true, resp.data);
      })
      .catch((err) => {
        if (err.response.data) {
          dispatch({ type: HASH_ERROR, payload: err.response.data });
          next(false, err.response.data);
        } else {
          dispatch({ type: HASH_ERROR, payload: err });
          next(false, err);
        }
      });
  });
}; */

export const wsPostHash = (dtoHash, next) => (dispatch) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`v1/auth/hash`, dtoHash)
      .then((resp) => {
        dispatch({ type: HASH_SUCCESS, payload: resp.data });
        next(true, resp.data);
      })
      .catch((err) => {
        if (err.response.data) {
          dispatch({ type: HASH_ERROR, payload: err.response.data });
          next(false, err.response.data);
        } else {
          dispatch({ type: HASH_ERROR, payload: err });
          next(false, err);
        }
      });
  });
};

export const hashReset = () => (dispatch) => {
  dispatch({
    type: HASH_LOGOUT,
  });
};
